import { useState } from 'react';
import tabSelect from '../../utils/tabSelect';
import './detailsTabs.css';
import Overview from './overView/Overview';
import Itinerary from './itinerary/Itinerary';
import Included from './included/Included';
import Reviews from './reviews/Reviews';
import FAQ from './FAQ/FAQ';
import { Rooms } from './rooms/Rooms';
import Dates from './Dates/Dates';
import TermsDis from './termsDis/TermsDis';
import Comments from './comments/comments';
import Safety from './safety/safety';
import Pickup from './pickup/Pickup';
import DatesCustom from './DatesCustom/DatesCustom';
import Bookings from './Bookings/Bookings';
import DatesCustomSup from './DatesCustomSup/DatesCustomSup';
import SupDates from '../SupDates/SupDates';
import Price from './Price/Price';
import UserDates from './userDates/UserDates';

export default function DetailsTabs({ tripDetailsData, isExpanded, setIsExpanded, typeSel, refresh, packDates }) {
    const [selectedTab, setSelectedTab] = useState('Overview');
    const meetupOrPickupTab =
        tripDetailsData.group === 'vehicle' || tripDetailsData.datesType === 'custom'
            ? { heading: 'Meetup', value: 'Meetup', for: 'both' }
            : { heading: 'Pickup', value: 'Pickup', for: 'both' };
    const tabs = [
        { heading: 'Rooms', value: 'Rooms', for: 'ayur' },
        { heading: 'Overview', value: 'Overview', for: 'both' },
        meetupOrPickupTab,
        { heading: 'Itinerary', value: 'Itinerary', for: 'trip' },
        { heading: 'Dates', value: 'Dates', for: 'both' },
        { heading: 'Inc/Exc', value: 'Including', for: 'both' },
        { heading: 'Safety', value: 'Safety', for: 'both' },
        { heading: 'Carry', value: 'Carry', for: 'both' },
        { heading: 'Reviews', value: 'Reviews', for: 'both' },
        { heading: 'FAQ', value: 'FAQ', for: 'both' },
        { heading: 'Terms', value: 'Terms', for: 'both' },
        { heading: 'Price', value: 'Price', for: 'org' },
        { heading: 'Bookings', value: 'Bookings', for: 'org' },
        { heading: 'Comments', value: 'Comments', for: 'org' }
    ];
    const whichType =
        window.location.pathname.split('/')[1] === 'org' || window.location.pathname.split('/')[1] === 'support'
            ? window.location.pathname.split('/')[2]
            : window.location.pathname.split('/')[1];

    const whichSection = window.location.pathname.split('/')[1];

    return (
        <div>
            <div
                className={
                    whichSection === 'org' || whichSection === 'support' ? 'orgTripDetailsTabs' : 'tripDetailsTabsUser'
                }
                style={{ position: 'sticky' }}
            >
                {tabs.map(function (tab, tabIndex) {
                    return (
                        <button
                            key={tabIndex}
                            className={`${
                                selectedTab === tab.value ? 'tripDetailsTabButtonHi' : 'tripDetailsTabButton'
                            } ${(whichType === 'trip' || whichType === 'guid') && tab.for === 'ayur' && 'tripHide'}
              ${whichType === 'camp' && tab.for === 'trip' && 'tripHide'}
              ${whichSection !== 'org' && whichSection !== 'support' && tab.for === 'org' && 'tripHide'}
              ${whichSection === 'support' && tab.for === 'ayur' && 'tripHide'}
                ${tripDetailsData.datesType === 'fixed' && tab.heading === 'Bookings' && 'tripHide'} 
                ${whichSection !== 'org' && whichSection !== 'support' && tripDetailsData.datesType === 'custom' && tab.heading === 'Dates' && 'tripHide'}`}
                            onClick={() => {
                                if (isExpanded) {
                                    setIsExpanded(false);
                                }
                                tabSelect(tab.value, setSelectedTab);
                            }}
                        >
                            {tab.heading}
                        </button>
                    );
                })}
            </div>
            <div className='tripDetailsInfoDiv'>
                {selectedTab === 'Overview' && <Overview data={tripDetailsData?.overview} />}
                {selectedTab === 'Rooms' && <Rooms data={tripDetailsData?.overview} />}
                {selectedTab === 'Itinerary' && <Itinerary data={tripDetailsData?.itinerary} />}
                {selectedTab === 'Including' && (
                    <Included dataInc={tripDetailsData?.included} dataExc={tripDetailsData?.excluded} />
                )}
                {selectedTab === 'Reviews' && <Reviews data={tripDetailsData} type={typeSel} />}
                {selectedTab === 'FAQ' && <FAQ data={tripDetailsData?.FAQ} />}
                {selectedTab === 'Terms' && <TermsDis data={tripDetailsData?.terms} />}
                {selectedTab === 'Safety' && <Safety type='safety' data={tripDetailsData?.safety} />}
                {selectedTab === 'Carry' && <Safety type='carry' data={tripDetailsData?.carry} />}
                {selectedTab === 'Pickup' && <Pickup type='pickup' data={tripDetailsData?.price} />}
                {selectedTab === 'Meetup' && <Pickup type='pickup' data={tripDetailsData?.price} />}
                {selectedTab === 'Price' && (
                    <Price
                        data={tripDetailsData?.price}
                        dateType={tripDetailsData.datesType}
                        group={tripDetailsData.group}
                    />
                )}

                {selectedTab === 'Dates' &&
                    (tripDetailsData.datesType === 'custom' ? (
                        whichSection === 'support' ? (
                            <DatesCustomSup
                                datesType={tripDetailsData.datesType}
                                data={tripDetailsData.unavailableDates}
                                refresh={refresh}
                                packData={tripDetailsData}
                            />
                        ) : (
                            <DatesCustom
                                datesType={tripDetailsData.datesType}
                                data={tripDetailsData.unavailableDates}
                                refresh={refresh}
                                packData={tripDetailsData}
                            />
                        )
                    ) : whichSection === 'org' ? (
                        <Dates
                            datesType={tripDetailsData.datesType}
                            data={tripDetailsData.unavailableDates}
                            refresh={refresh}
                            packData={tripDetailsData}
                        />
                    ) : whichSection === 'support' ? (
                        <SupDates
                            datesType={tripDetailsData.datesType}
                            data={tripDetailsData.unavailableDates}
                            refresh={refresh}
                            packData={tripDetailsData}
                        />
                    ) : (
                        <UserDates
                            datesType={tripDetailsData.datesType}
                            data={tripDetailsData.unavailableDates}
                            refresh={refresh}
                            packData={tripDetailsData}
                            packDates={packDates}
                        />
                    ))}
                {selectedTab === 'Bookings' && <Bookings packData={tripDetailsData} refresh={refresh} />}
                {selectedTab === 'Comments' && <Comments data={tripDetailsData?.supComments} />}
            </div>
        </div>
    );
}
